// Cómo se le presenta al usuario el reto 3DS de Conekta.
//
//   'redirect' → se navega la ventana completa a Conekta y se regresa por
//                `return_url`. Es lo que hacen las pasarelas de pago, y deja el
//                reto en primer nivel: sin storage particionado ni iframes
//                anidados, que es de donde salían varias de las fallas.
//   'iframe'   → el comportamiento anterior, embebido en el modal. Se conserva
//                como vuelta atrás de una línea si la redirección da problemas.
export const CONEKTA_3DS_PRESENTATION = 'redirect';

export const isRedirectMode = () => CONEKTA_3DS_PRESENTATION === 'redirect';
export const isIframeMode = () => CONEKTA_3DS_PRESENTATION === 'iframe';

// `source=embbeded` solo sirve dentro de un iframe: hace que Conekta avise con
// `window.parent.postMessage`. En redirección hay que usar la URL cruda, para
// que Conekta navegue a la `return_url` al terminar.
export const usesEmbeddedUrl = () => isIframeMode();
